/**
 * Decodifica um JWT token para extrair payload sem verificar assinatura
 * @param token Token JWT
 * @returns Payload decodificado ou null se inválido
 */
export function decodeToken(token: string): any {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Erro ao decodificar token:', error);
    return null;
  }
}

/**
 * Obtém o payload do token armazenado no localStorage
 */
export function getTokenPayload(): any {
  try {
    const token = localStorage.getItem('SGI_TOKEN');
    if (!token) return null;
    
    return decodeToken(token);
  } catch (error) {
    console.error('Erro ao obter payload do token:', error);
    return null;
  }
}

/**
 * Interface para o payload do token
 */
export interface TokenPayload {
  userId?: number | null;
  personCPF: string;
  iat: number;
  exp: number;
}
